

























































































import Vue from "vue";
import moment from "moment";
import statusQuery from "@/common/mixins/statusQuery";
import pagination from "@/common/mixins/pagination";
import dialog from "@/common/mixins/dialog";
import { ErrorEventFilterForm } from "../forms/ErrorEventFilterForm";
import { ErrorEvent } from "../models/ErrorEvent";
export default Vue.extend({
  mixins: [pagination, statusQuery, dialog],
  data() {
    const errorItems: ErrorEvent[] = [];
    return {
      errorItems,
      notificationId: "",
      start: "",
      end: ""
    };
  },
  async created() {
    (this as any).getPaginationRouteQuery();
    (this as any).getStatusRouteQuery();
    await this.getErrorEvent();
  },
  watch: {
    async "$route.query"() {
      await this.getErrorEvent();
    }
  },
  methods: {
    async getErrorEvent() {
      try {
        const startDt = new Date(this.start);
        const endDt = new Date(this.end);
        const {
          data,
          meta
        } = await (this as any).$dep.errorEventUseCase.filterErrorNotification(
          {
            search: this.notificationId,
            fromDate: this.start
              ? moment(startDt.setHours(startDt.getHours() - 7)).format()
              : "",
            toDate: this.end
              ? moment(endDt.setHours(endDt.getHours() - 7)).format()
              : ""
          },
          {
            page: (this as any).currentPage,
            perPage: (this as any).perPage
          }
        );
        this.errorItems = data;
        (this as any).setPaginationMeta(meta);
      } catch (error) {
        (this as any).alertError("Error", error.response.data.message);
      }
    },
    async onRowClicked(errorId: number) {
      await (this as any).$dep.errorEventUseCase.updateAcknowledgement(errorId);
      this.$router.push({
        name: "ErrorEventFromNotiIdViewPage",
        params: { id: String(errorId) }
      });
    }
  }
});
